import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

type AddToCartModalProp = {
  name: string
}

const AddToCartModal = ({ name }: AddToCartModalProp) => {

  const params = useParams();


  const handleCloseModal = () => {
    const modalElement = document.getElementById('modalAddToCart');
    if (modalElement) {
      const bootstrap = (window as any).bootstrap;
      const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
      modalInstance.hide();
    }

    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };


  return (
    <div className="modal fade" id="modalAddToCart" tabIndex={-1} style={{ display: "none" }} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Handlekurv</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
          </div>
          <div className="modal-body">
            <p><strong className="d-inline-block">{name}</strong> er lagt til i handlekurven</p>
          </div>
          <div className="modal-footer">
            <Link to={UrlPath.Account.WebShopBase + "/" + params.id } onClick={handleCloseModal} >Fortsett å handle</Link><Link to={UrlPath.Account.ShoppingCartBase} className="btn btn-primary" onClick={handleCloseModal}  >Vis handlekurv</Link>
          </div>
        </div>
      </div>
    </div>)
}

export default AddToCartModal;